import {
  AuthMode,
  GetAuthorizationHeader
} from '~/adapters/services/shared/apiCall';
import openApiFetch, {Middleware} from 'openapi-fetch';
import {useMemo} from 'react';
import {getEnv} from '~/adapters/config/env';
import {Config} from '~/adapters/config/config';
import {useAuth} from '~/auth/AuthContext';
import {AccountsApiClient} from './accountsApiClient';
import {paths} from './schema';

export const useAccountsApiClient = () => {
  const baseUrl = getEnv('NDX_ACCOUNTS_SERVICE_URL');

  const {identityProvider, getTokens, user} = useAuth();
  const authMode: AuthMode =
    identityProvider === 'auth0'
      ? {withAccessToken: true}
      : {withIdToken: true};
  const headers = {
    'client-name': 'ndx',
    'client-version': Config.VITE_RELEASE
  };

  const client = openApiFetch<paths>({baseUrl, headers});

  const middleware: Middleware = {
    onRequest: async req => {
      const authorizationToken = await GetAuthorizationHeader({
        url: req.request.url,
        getTokens,
        identityProvider,
        user,
        authMode,
        queryParams: req.params.query
      });
      if (authorizationToken) {
        req.request.headers.set('Authorization', authorizationToken);
      }
      return req.request;
    }
  };
  client.use(middleware);

  return useMemo(() => new AccountsApiClient(client), [client]);
};
